import React, { Component } from 'react'
import pedidoslogo from '../img/pedidos-logo.png'
import Barcode from 'react-barcode'
import AppContext from '../../appContext';

class PDFOrderHeader extends Component {
	constructor() {
		super();
		PDFOrderHeader.contextType = AppContext;
	}

    render() {
        const { dados, isLabOG, isPedidoPromocional } = this.props;
        const pedidoParaBarcode = isLabOG
            ? (dados.idPedidoOpticlick || dados.pedido)
            : dados.pedido;
        const textoPedido = isLabOG && dados.idPedidoOpticlick
            ? `Nº do Pedido: ${dados.idPedidoOpticlick}`
            : `Nº do Pedido: ${dados.pedido}`;

        const logoSrc = isPedidoPromocional
            ? "/image/modulos/conecta_pedidos_promocionais_transparente.png"
            : pedidoslogo;

        return (
            <div className="pdf-order-header row">
                <div className="col-6 text-left">
                    <img src={logoSrc} width="178" height="120" alt="Logo Pedidos" />
                </div>
                <div className="col-6 text-end">
                    <Barcode value={String(pedidoParaBarcode)} height="70" text={textoPedido} />
                    {dados.idPedidoOpticlick && isLabOG && (
                        <p style={{ marginTop: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                            idPedidoOpticlick
                        </p>
                    )}
                </div>
				<div className="col-6">
                    <p className="pdf-subtitle"><b>Laboratório:</b> <br />
                        {dados.laboratorio}
                    </p>
                </div>
				{dados.valor_pedido && this.context.userSession.modulos.includes("Pedidos Valores") && (
				  <div className="col-6">
				    <p className="pdf-subtitle">
					  <b>Valor total do pedido:</b> <br />
					  {dados.valor_pedido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
					</p>
				  </div>
				)}
            </div>
        )
    }
}

export default PDFOrderHeader